import { RegistrationToken } from '../../models';
import { Observable } from 'rxjs';

export interface INotificationService {
  setRegistrationToken(registrationToken: RegistrationToken): Promise<any>;

  removeRegistrationToken(userId: string): Promise<any>;
}
